// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader'
import Masthead from '@ta-interaktiv/react-masthead'
import Footer from '../footer'
import { ThemeSwitch as themeSwitch } from '@ta-interaktiv/react-theme-switch'
import Scrollchor from 'react-scrollchor'
import './styles.scss'

const ARTICLE_ID = '14402168'

class AppComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      publicationDate: Date.now() / 1000
    }

    themeSwitch({ mediaName: 'tdg' })
  }
  render () {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Comment la démocratie suisse absorbe le populisme
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
              La Suisse et son système politique font figure de modèles pour de nombreux partis
              populistes en Europe. Pourtant, chez nous, même en année d’élections fédérales, ce n’est
              pas un enjeu. Décodage
              </div>
            </h2>
            <p className='ta author'>
              Lise Bailat
            </p>
          </div>
        </header>

        <figure
          className='illustration-wrapper ui container'
          style={{ marginBottom: '.15em' }}
        >
          <img
            alt='Illustration'
            src={require('./im3.jpg')}
          />
        </figure>

        <main className='ui vertical segment' style={{ marginTop: '4em' }}>
          <div className='ui text container' style={{ position: 'relative' }}>
            <p style={{ marginTop: '2em' }}>
              De Rome à Berlin, de Budapest à Paris, on n'a parlé que de cela durant des mois: quel
              serait donc le score des partis populistes aux élections européennes? Le 26 mai, la
              vague eurosceptique s'est matérialisée dans les urnes. <a href='https://www.tdg.ch/11463105'>La prochaine législature sera
              dominée en partie par les droites traditionnelles et extrêmes, même si les Verts ont
              confirmé leur progression.</a>
            </p>
            <p>
              En Suisse aussi 2019 est une année d’élections. Le peuple et les cantons
              renouvelleront leurs autorités fédérales cet automne. Pourtant, la montée du
              populisme n’est pas un réel enjeu. Pourquoi? Le pays serait-il une île imperméable
              aux bouleversements politiques qui secouent le continent? Non, répondent en chœur
              Pascal Sciarini, Yannis Papadopoulos et Nenad Stojanovic, trois politologues de
              l’Université de Genève (UNIGE) et de Lausanne (UNIL) que nous avons sollicités. Mais
              la situation helvétique est tout à fait particulière. Voici pourquoi.
            </p>

            <ul className='nav' id='nav'>
              <Scrollchor to='#question-1'><li className='question-link' onClick={this.trackNavClicks}>1. Le populisme en Suisse, un gros mot?</li></Scrollchor>
              <Scrollchor to='#question-2'><li className='question-link' onClick={this.trackNavClicks}>2. Le cas du MCG et de la Lega dei Ticinesi</li></Scrollchor>
              <Scrollchor to='#question-3'><li className='question-link' onClick={this.trackNavClicks}>3. Et les populismes de gauche?</li></Scrollchor>
              <Scrollchor to='#question-4'><li className='question-link' onClick={this.trackNavClicks}>4. Pourquoi le populisme n’est pas un enjeu des fédérales</li></Scrollchor>
              <Scrollchor to='#question-5'><li className='question-link' onClick={this.trackNavClicks}>5. La démocratie suisse, frein ou accélérateur de populismes?</li></Scrollchor>
            </ul>

            <div className='ui question container' id='question-1' style={{textAlign: 'left'}}>
              <h2><span className='title-text'>1. Le populisme en Suisse, un gros mot?</span><Scrollchor to='#nav'><div className='top-link' onClick={this.trackTopClicks}><div className='arrow-text'>revenir</div> <i className='chevron up icon' /></div></Scrollchor></h2>
            </div>

            <aside
              className='ui vertical very fitted segment widescreen hidden large screen hidden small'
              style={{ marginBottom: '1em' }}
            >
              <a href='https://www.tdg.ch/monde/populisme'>
                <div className='story-hint'>
                  <img src={require('./dossier.jpg')} style={{ width: '120px' }} />
                  <div className='hint-container'>
                    Retrouvez tous les articles de{' '}
                    <nobr>
                      <span className='pseudo-link'>notre dossier</span>
                    </nobr> spécial populisme.
                  </div>
                </div>
              </a>
            </aside>
            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '35%' }}
            >
              <a href='https://www.tdg.ch/monde/populisme'>
                <div className='story-hint'>
                  <img src={require('./dossier.jpg')} style={{ width: '100%' }} />
                  <div className='hint-container'>
                    Retrouvez tous les articles de{' '}
                    <nobr>
                      <span className='pseudo-link'>notre dossier</span>
                    </nobr> spécial populisme.
                  </div>
                </div>
              </a>
            </aside>

          </div>
          <div className='ui text container' style={{ position: 'relative' }}>

            <p>
            Quand on dit populisme en Suisse, les projecteurs se braquent immédiatement sur un parti:
            l’UDC. Est-ce une formation populiste? «On parle de l’UDC comme d’un parti national-
            conservateur, ce qui est correct. Mais il y a pour moi dans le discours UDC des éléments
            populistes, précisément dans l’appel au peuple contre des élites qui n’agiraient pas
            correctement», affirme Pascal Sciarini, professeur en sciences politiques à l'UNIGE. “Le
            discours de Christoph Blocher est clairement populiste. D’autres personnalités de l’UDC
            n’ont pas la même approche. Mais le parti, aujourd’hui, est quand même à son image»,
            ajoute Nenad Stojanovic, professeur FNS à l'UNIGE. Pourtant, dans le discours commun, on
            qualifie rarement l’UDC de parti populiste. Un tabou suisse? Yannis Papadopoulos n’est pas
            d’accord: «Ceux qui sont contre l’UDC la traite régulièrement de populiste», ce qui selon lui
            est «techniquement correct».
            </p>

            <div className='ui text container'>
              <figure
                className='illustration-wrapper ui container'
                style={{ marginBottom: '.15em' }}
              >
                <img
                  alt='Illustration'
                  src={require('./im2.jpg')}
                />
              </figure>
            </div>

            {/* <div className='blockquote-wrapper'>
              <blockquote>
                <p>Le populisme est une idéologie qu’on peut retrouver un peu partout sur l’échiquier politique.</p>
              </blockquote>
              <cite>– Yannis Papadopoulos</cite>
            </div> */}

            <p>
            Pour en expliquer les raisons, il faut s’entendre sur ce qu’est le populisme. Nos trois experts
            s’accordent sur une définition de base: «Le populisme est une idéologie qu’on peut retrouver
            un peu partout sur l’échiquier politique. La base minimale est la glorification du peuple,
            considéré comme un tout homogène, dont la souveraineté doit s’exercer sans entrave,
            explique Yannis Papadopoulos, professeur en politique suisse à l’UNIL. À cela s’ajoute un
            côté antiélites. On joue la grande majorité contre un nombre restreint d’élites affublées de
            caractéristiques négatives: incompétence, égoïsme, etc». Pascal Sciarini y ajoute aussi la
            propension des populistes à faire appel à un discours simpliste, au besoin en recourant à
            la stratégie du bouc émissaire.
            </p>
            <p>
            Est-ce positif ou négatif? «Pour
            moi, être populiste n’est pas connoté négativement. On parle d’idéologie populiste, comme
            d’idéologie socialiste ou libérale», affirme Yannis Papadopoulos. «Il y a un grand débat
            au sein des milieux académiques sur le populisme. Certains y voient des côtés positifs: il
            permet à toute une série de personnes qui n’étaient pas représentées à travers les partis
            traditionnels de s’engager dans le débat. On le voit en France, pour prendre un exemple
            récent. Mais à partir du moment où un parti populiste s’empare du pouvoir, il a une tendance
            à détruire les institutions qui lui ont permis d’y arriver. Le danger, c’est l’intolérance inhérente
            au populisme», ajoute Nenad Stojanovic, citant le cas du Venezuela ou de la Hongrie.
            </p>
          </div>

          <div className='ui text container' style={{ position: 'relative' }}>
            <div className='ui question container' id='question-2' style={{textAlign: 'left'}}>
              <h2><span className='title-text'>2. Le cas du MCG et de la Lega dei Ticinesi</span><Scrollchor to='#nav'><div className='top-link' onClick={this.trackTopClicks}><div className='arrow-text'>revenir</div> <i className='chevron up icon' /></div></Scrollchor></h2>
            </div>

            <p>
            L’UDC n’a pas l’apanage du populisme en Suisse. La Lega au Tessin, et le Mouvement
            citoyens genevois répondent aussi à la définition, selon les experts. «Il y a dans leur
            discours cette idée d’une défense culturelle, identitaire, qui se double d’une défense
            économique, mais à un niveau cantonal, analyse Pascal Sciarini. Les deux partis sont, cela
            dit, un peu différents de l’UDC, parce que sur les questions de politique économique et
            sociales, ils ont aussi des filtres de gauche». Yannis Papadopoulos ajoute: «Pour moi, le MCG
            est un exemple de populisme centriste». Et la Lega? Tessinois d’origine, Nenad Stojanovic a
            une idée claire sur le sujet: «Selon la définition, elle mène un populisme de droite, dans la
            mesure où elle parle d’un peuple ethniquement unifié.»
            </p>

            <div className='ui question container' id='question-3' style={{textAlign: 'left'}}>
              <h2><span className='title-text'>3. Et les populismes de gauche?</span><Scrollchor to='#nav'><div className='top-link' onClick={this.trackTopClicks}><div className='arrow-text'>revenir</div> <i className='chevron up icon' /></div></Scrollchor></h2>
            </div>

            <p>
            Le populisme existe aussi à gauche. Mais en Suisse il est plus difficile à identifier. Pascal
            Sciarini explique: «Le populisme de droite met l’accent sur le peuple en tant que nation et
            articule son discours sur les questions culturelles et identitaires. Le populisme de
            gauche, lui, est un populisme de classe. Les enjeux sont économiques. On cherche à défendre le peuple
            des opprimés, des défavorisés contre les nantis. En Suisse, on a des traces de ce
            populisme de gauche, à l’extrême gauche, notamment à Genève.» Le professeur genevois
            se souvient de prises de position antifrontaliers venant de la gauche, dans l’idée que les
            frontaliers menaceraient économiquement les résidents cantonaux. «Il y a aussi des
            éléments populistes dans le discours de la gauche et de l’extrême-gauche suisses, mais ils
            sont moins prononcés», affirme Yannis Papadopoulos. «Au Tessin, il existe un Mouvement
            pour le socialisme, qui incarne le populisme de gauche», ajoute Nenad Stojanovic. Mais ce
            courant-là reste marginal en terres helvétiques. Pourquoi? Pascal Sciarini a une
            explication: «Le populisme de droite est dominant en Suisse parce qu’il est incarné par l’UDC sur un
            discours identitaire et que le pays n’a pas eu de crise économique majeure qui aurait
            pu favoriser un discours populiste de gauche.»
            </p>

            <div className='ui question container' id='question-4' style={{textAlign: 'left'}}>
              <h2><span className='title-text'>4. Pourquoi le populisme n’est pas un enjeu des fédérales</span><Scrollchor to='#nav'><div className='top-link' onClick={this.trackTopClicks}><div className='arrow-text'>revenir</div> <i className='chevron up icon' /></div></Scrollchor></h2>
            </div>

            <p>
            La Suisse ne fait donc pas figure d’exception dans le paysage politique européen. Presque
            30% des votants ont élu en 2015 des représentants d’un parti populiste à Berne. Pourtant, à
            l’aube des élections fédérales, la montée du populisme n’est pas un thème de campagne. Et
            pour cause:  «D’une manière objective, la possibilité réelle que l’UDC obtienne la majorité au
            parlement, au Conseil fédéral et dans les Cantons n’existe pas. On sait que c’est un parti
            important. Mais 30%, ce n’est pas 51%“, explique Nenad Stojanovic. Autrement dit, le risque
            réel d’une dérive autoritaire par la prise du pouvoir d'un seul parti n’est guère marqué en Suisse. Pascal Sciarini souligne une
            autre composante: “Le populisme est peu dangereux en Suisse parce que nous avons des
            institutions solides et une démocratie qui fonctionne. Il y a une forme de maturité, de respect
            des règles du jeu de la part du peuple et des partis politiques.»
            </p>
          </div>

          <div className='ui text container' style={{ position: 'relative' }}>
            <div className='ui question container' id='question-5' style={{textAlign: 'left'}}>
              <h2><span className='title-text'>5. La démocratie suisse, frein ou accélérateur de populismes?</span><Scrollchor to='#nav'><div className='top-link' onClick={this.trackTopClicks}><div className='arrow-text'>revenir</div> <i className='chevron up icon' /></div></Scrollchor></h2>
            </div>

            <p>
              C’est tout le paradoxe. La démocratie semi-directe fait rêver nombre de partis populistes
              européens, du Front national à l’Alternative für Deutschland en passant par Cinque Stelle en
              Italie. Ils y voient la manière de rendre la parole au peuple. C’est parce qu’ils ne
              comprennent pas le système suisse, rétorque Nenad Stojanovic. Ce dernier mène un projet
              de recherche sur le sujet. Avec pour thèse: la démocratie directe est un frein au populisme.
              Il explique ses premiers résultats: «Un tel système démocratique, pratiqué fréquemment et
              pas tous les dix ans, crée par sa nature même une situation où tous les votants sont parfois
              perdants, parfois gagnants. C’est fondamental: personne n’est toujours en majorité ou en
              minorité. Et cela démontre de façon permanente qu’il n’existe pas de peuple unifié ou
              homogène comme les populistes aiment en donner l’illusion.»
            </p>
          </div>

          <div className='ui text container'>
            <figure
              className='illustration-wrapper ui container'
              style={{ marginBottom: '.15em' }}
            >
              <img
                alt='Illustration'
                src={require('./im1.jpg')}
              />
            </figure>
          </div>

          <div className='ui text container' style={{ position: 'relative' }}>

            {/* <div className='blockquote-wrapper'>
              <blockquote>
                <p>La démocratie directe permet à certaines expressions, qu’on peut qualifier de populistes, de pouvoir s’exprimer.</p>
              </blockquote>
              <cite>– Nenad Stojanovic</cite>
            </div> */}

            <p>
              Deuxième bienfait de la démocratie directe à la mode helvétique: elle fait office, selon lui, de
              soupape de sécurité. «Elle permet à certaines expressions qu’on peut qualifier de populistes
              de pouvoir s’exprimer. Chacun peut lancer une initiative populaire ou saisir le référendum.
              En Suisse, si vous ne voulez pas d’une surtaxe sur l’essence, vous n’avez pas besoin
              d’occuper les Champs-élysées.» Pascal Sciarini le rejoint: «On cite toujours, pour accréditer
              la thèse selon laquelle la démocratie directe favoriserait le populisme, le vote sur les
              minarets ou sur l&#39;immigration. C’est oublier que, dans leur majorité, les votes populaires
              donnent raison aux autorités.» Il ajoute: «La démocratie directe a aussi permis en un sens de
              recadrer et de tenir les élites sous contrôle.»
            </p>
            <p>
              Pour autant, les deux politologues de l’Université de Genève n’idéalisent pas le système
              suisse. «On ne peut pas nier que la montée en puissance de l’UDC a été favorisée par la
              démocratie directe. Le parti a pu lancer des initiatives, actionner des référendums pour
              favoriser son discours”, affirme Pascal Sciarini. À Lausanne, Yannis Papadopoulos résume:
              «Le populisme n’est pas une conséquence de la démocratie directe. Mais la démocratie
              directe est un de ses canaux d’expressions. Les populistes arrivent au pouvoir par des élections.»
            </p>

            <aside
              className='ui vertical very fitted segment widescreen hidden large screen hidden small'
              style={{ marginBottom: '1em' }}
            >
              <a href='https://www.tdg.ch/monde/populisme'>
                <div className='story-hint'>
                  <img src={require('./dossier.jpg')} style={{ width: '120px' }} />
                  <div className='hint-container'>
                    Retrouvez tous les articles de{' '}
                    <nobr>
                      <span className='pseudo-link'>notre dossier</span>
                    </nobr> spécial populisme.
                  </div>
                </div>
              </a>
            </aside>
            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '20%' }}
            >
              <a href='https://www.tdg.ch/monde/populisme'>
                <div className='story-hint'>
                  <img src={require('./dossier.jpg')} style={{ width: '100%' }} />
                  <div className='hint-container'>
                    Retrouvez tous les articles de{' '}
                    <nobr>
                      <span className='pseudo-link'>notre dossier</span>
                    </nobr> spécial populisme.
                  </div>
                </div>
              </a>
            </aside>

          </div>
        </main>

        <Footer
          articleId={ARTICLE_ID}
          publicationDate={this.state.publicationDate}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
